<template>
  <transition name="modal">
    <div
      class="modal-mask"
      role="dialog"
      aria-labelledby="modalTitle"
      aria-describedby="modalDescription"
    >
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modaloption-header">
            <template v-if="message">
              <slot name="header">
                <h3 v-translate>Options</h3>
              </slot>
            </template>
            <template v-else>
              <slot name="header">
                <h3 v-translate>Please confirm action</h3>
              </slot>
            </template>
          </div>
          <div class="modaloption-body">
            <slot name="body">
              <template v-if="message">
                <translate>{{ message }}</translate>
              </template>
            </slot>
          </div>
          <div class="modaloption-footer">
            <slot name="footer">
              <div v-for="(button, index) in options" :key="index">
                <button @click="confirm(button.emitEvent)" 
                  class="btn btn-default modal-default-button px-4">
                  {{ button.label }}
                </button>
              </div>

              <button
                class="btn btn-default modal-default-button px-4"
                @click="cancel"
                v-translate
              >
                Cancel
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "ConfirmModal",
  props: ["message", "options"],
  computed: {},
  data() {
    return {
      confirmed: false,
    };
  },
  methods: {
    async confirm(event) {
      if (this.confirmed) return;
      this.$emit('callback', event);
    },
    cancel() {
      this.$emit("cancelModalOption");
    },
  },
  watch: {
    isLoading: {
      handler(after) {
        console.log("Modal handler isLoading");
      },
    },
  },
  mounted() {

  },
};
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  z-index: 9999;
  z-index: 9999;
  width: auto;
  min-width: 300px;
  max-width: 800px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
  justify-content: center;
  align-items: center;
}

.modaloption-header h3 {
  margin-top: 0;
  color: #42b983;
  text-align: center;
  /* width: auto; */
  min-width: 300px;
  max-width: 800px;
  justify-content: center;
  align-items: center;
}

.modaloption-body {
  display: flex;
  margin: 20px 0;
  width: auto;
  min-width: 300px;
  max-width: auto;
  justify-content: center;
  align-items: center;
}
.modaloption-footer
{
  display: flex;
  flex-wrap: wrap;
  margin: 20px 0;
  max-width: auto;
  justify-content: center;
  align-items: center;
  gap: 10px;
}
.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
